import objectPath from 'object-path'

const getRuleCallTableApiTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

export const onRuleCallTableApi = (
  designContext = {},
  action = {},
  data = {},
  target = '',
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let isWaitUpsert = objectPath.get(isUiChanged, 'isWaitUpsert') || {}
  let targetKey = isWaitUpsert.key || getRuleCallTableApiTarget(action, target)
  if (!targetKey) return undefined

  let formData = data.formData || designContext.jsonForm?.formData || {}
  let { isAddRow, isEditRow, isReplace, rowData } = isWaitUpsert
  let newData = objectPath.get(formData, [targetKey, 0])

  if (isAddRow) {
    objectPath.set(isUiChanged, [targetKey], { isAddRow: true, newData })
  } else if (isEditRow) {
    objectPath.set(isUiChanged, [targetKey], { isEditRow: true, newData })
  } else if (isReplace) {
    let rowEdit = objectPath.get(isUiChanged, '@rowEdit') || {}
    newData = objectPath.get(rowData, [0]) || {}
    newData = { ...rowEdit, ...newData }
    objectPath.set(isUiChanged, [targetKey], { isEditRow: true, newData })
  } else {
    objectPath.del(isUiChanged, [targetKey])
  }
  objectPath.del(isUiChanged, 'isWaitUpsert')
  if (setIsUiChanged) setIsUiChanged(isUiChanged)

  return {
    key: targetKey,
    newData,
  }
}
